import React, { Component } from 'react'
import { Col, Form, InputNumber, Row, Slider, Space, Typography } from 'antd'

type QuestionRangeProps = {
  start?: number,
  end?: number,
  step?: number
}

export default class QuestionRange extends Component<QuestionRangeProps> {

  state = {
    previewRangeValue: 0,
    rangeValues: {
      start: this.props.start || 0,
      end: this.props.end || 0,
      step: this.props.step || 0
    }
  }

  handleRangeConfigChange = (name: string, value: any) => {
    this.setState((state: any) => ({
      ...state,
      rangeValues: {
        ...state.rangeValues,
        [name]: value
      },
      previewRangeValue: state.rangeValues.end > 1 ? (Number(state.rangeValues.end / 2)) : 0
    }))
  }

  handleRangePreviewChange = (value: any) => {
    this.setState({
      previewRangeValue: value
    })
  }

  render() {
    const { previewRangeValue, rangeValues: { start, end, step } } = this.state

    return (
      <Space direction="vertical">
        <Row>
          <Col span={8}>
            <Form.Item
              label="Range Start"
              name={['rule', 'start']}
              rules={[
                {
                  required: true,
                  message: 'Missing answer range start'
                }
              ]}
            >
              <InputNumber placeholder="Range Start" min={0} style={{width: '90%'}} onChange={(values: any) => this.handleRangeConfigChange('start', values)} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Range End"
              name={['rule', 'end']}
              rules={[
                {
                  required: true,
                  message: 'Missing answer range end'
                }
              ]}
            >
              <InputNumber placeholder="Range End" min={0} style={{width: '90%'}} onChange={(values: any) => this.handleRangeConfigChange('end', values)} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Range Step"
              name={['rule', 'step']}
              rules={[
                {
                  required: true,
                  message: 'Missing answer range step'
                }
              ]}
            >
              <InputNumber placeholder="Range Step" min={1} style={{width: '90%'}} onChange={(values: any) => this.handleRangeConfigChange('step', values)} />
            </Form.Item>
          </Col>
        </Row>

        {
          end > 0 && step > 0 ? (
            <>
              <Typography>Preview</Typography>
              <Slider
                value={previewRangeValue}
                min={start}
                max={end}
                step={step}
                dots={true}
                onChange={this.handleRangePreviewChange}
              />
            </>
          ) : null
        }
      </Space>
    )
  }
}
